<template>
  <jczh-drawer
    title="选择申请单品目"
    :visible.sync="visible"
    confirm-button-text="确定"
    size="1150px"
    :el-attrs="{
      destroyOnClose: true
    }"
    @close="closeDialog"
    @confirm="confirmFun"
  >
    <template v-slot:content>
      <div class="dialog-content m-t-20">
        <!--过滤表单-->
        <el-form
          :model="filterForm"
          :inline="true"
          label-suffix="："
          size="small"
        >
          <el-form-item label="采购申请单编号">
            <el-input
              v-model="filterForm.requireCode"
              placeholder="请输入采购申请单编号"
            />
          </el-form-item>
          <el-form-item label="品目名称/编号">
            <el-input
              v-model="filterForm.itemCodeOrName"
              placeholder="请输入品目名称"
            />
          </el-form-item>
          <el-form-item label="来源">
            <el-select v-model="filterForm.source">
              <el-option label="全部" value="" />
              <el-option
                v-for="item in materialSourceDict.array"
                :key="item.label"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="handleSearch">
              查询
            </el-button>
            <el-button size="small" @click="handleReset">
              重置
            </el-button>
          </el-form-item>
        </el-form>

        <!--已选择的品目-->
        <el-form label-suffix="：" label-width="110px">
          <el-form-item label="已选品目">
            <el-tag
              v-for="(tag, index) in selectedMaterialList"
              :key="tag.itemId"
              closable
              type="primary"
              class="m-r-10 m-b-5"
              @close="deleteMaterial(index)"
            >
              {{ tag.itemName }}
            </el-tag>
          </el-form-item>
        </el-form>

        <material-item-table
          :table-list="tableList"
          :echo-list="selectedMaterialList"
          :table-config-fun="() => tableOption"
          :show-operation="false"
          table-id="itemId"
          @selectionChange="selectionChange"
        />

        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="page"
          :limit.sync="size"
        />
      </div>
    </template>
  </jczh-drawer>
</template>

<script>
// 组件
import MaterialItemTable from '@/components/common/MaterialComponent/MaterialItemTable'
import Pagination from '@/components/common/Pagination'

// mixin
import listFilterMixin from '@/mixins/list-filter-mixin'

// 数据字典
import {
  hasFrameworkAgreementDict,
  materialSourceDict,
  materialStatusDict
} from '@/dictionary/purchase-demand'

// 后端api
import { getPurchaseApplyMaterialListApi } from '@/api/purchase-demand/plan'
import { uniq } from 'lodash'

export default {
  name: 'SelectMaterialDialog',

  components: { MaterialItemTable, Pagination },

  mixins: [listFilterMixin],

  props: {
    showDialog: {
      type: Boolean,
      required: true
    },

    echoList: {
      type: Array,
      default: () => []
    },

    /**
     * 选择品目的类型 1：指派执行人 2：制定方案
     */
    pickType: {
      type: Number,
      default: 2
    },

    /**
     * 品目是否分配： 0：未分配 1：已分配
     */
    hasExecutor: {
      type: [Number, String],
      default: ''
    }
  },

  data() {
    return {
      materialSourceDict,

      // 搜索表单
      filterForm: {
        requireCode: '',
        itemCodeOrName: '',
        source: ''
      },

      // 品目数据数组
      selectedMaterialList: [],
      tableList: [],
      tableOption: [
        { label: '申请单编号', prop: 'requirementCode', minWidth: 100 },
        { label: '品目编码', prop: 'itemCode', minWidth: 100 },
        { label: '品目名称', prop: 'itemName', minWidth: 100 },
        { label: '参数型号', prop: 'itemModel', minWidth: 100 },
        {
          label: '品目来源',
          prop: 'source',
          minWidth: 100,
          filter: value => materialSourceDict.translate(value)?.label || '-'
        },
        { label: '品牌/制造商', prop: 'itemBrand', minWidth: 100 },
        { label: '品目单位', prop: 'unitType' },
        { label: '数量', prop: 'itemNum' },
        {
          label: '协议框架',
          prop: 'agreementFlag',
          filter: value =>
            hasFrameworkAgreementDict.translate(value)?.label || '-'
        },
        { label: '申请人', prop: 'applierName' },
        { label: '申请时间', prop: 'applyTime', minWidth: 160 }
      ],
      total: 0
    }
  },

  computed: {
    visible: {
      get() {
        return this.showDialog
      },
      set(val) {
        this.$emit('update:showDialog', val)
      }
    }
  },

  watch: {
    showDialog(newVal) {
      if (newVal) {
        this.selectedMaterialList = this.echoList || []
        this.getList()
      }
    },

    echoList(newVal) {
      this.selectedMaterialList = this.echoList
    }
  },

  methods: {
    closeDialog() {
      this.filterForm = {
        requireCode: '',
        itemCodeOrName: '',
        source: ''
      }
      this.page = 1
    },

    /**
     * 获取待分配的品目列表
     * @param selection
     */
    getList() {
      this.epitaxy()

      getPurchaseApplyMaterialListApi(
        Object.assign({}, this.filterForm, {
          queryType: this.pickType,
          hasExecutor: this.hasExecutor,
          hasPlan: this.pickType === 2 ? 0 : '',
          isDel: 0,
          page: this.page,
          size: this.size
        })
      )
        .then(res => {
          const data = res?.data || {}
          this.tableList = data?.records || []
          this.total = data?.total || 0
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    /**
     * 删除已选的品目
     */
    deleteMaterial(index) {
      this.selectedMaterialList.splice(index, 1)
    },

    selectionChange(selection) {
      this.selectedMaterialList = selection
    },

    async confirmFun() {
      // 判断勾选的品目中是否有已经作废了的
      const isSome = this.selectedMaterialList.some(
        item => item.isDel === materialStatusDict.VOID.value
      )
      if (isSome) {
        await this.$confirm(`已作废的品目不可采购`, '系统提示', {
          type: 'warning'
        })
        return
      }

      // 判断勾选的品目是否含有多种来源
      const sourceArray = uniq(
        this.selectedMaterialList.map(value => value.source)
      )
      if (sourceArray.length > 1) {
        await this.$confirm(`品目来源不同，请检查后重试`, '系统提示', {
          type: 'warning'
        })
        return
      }

      this.$emit('confirm', this.selectedMaterialList)
      this.visible = false
    }
  }
}
</script>
